import { createTheme } from '@mui/material';

export const DarkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#64b5f6', // Azul mais suave e moderno
      dark: '#1976d2', // Azul mais escuro para hover/states
      light: '#90caf9', // Azul mais claro
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#80deea', // Ciano mais suave
      dark: '#4bacb8', // Ciano escuro
      light: '#b2ebf2', // Ciano claro
      contrastText: '#0d47a1', // Texto com bom contraste
    },
    error: {
      main: '#f44336', // Vermelho padrão Material UI
      dark: '#d32f2f', // Vermelho escuro
      light: '#e57373', // Vermelho claro
      contrastText: '#ffffff',
    },
    warning: {
      main: '#ffa726', // Laranja para alertas
      dark: '#f57c00',
      light: '#ffb74d',
      contrastText: '#000000',
    },
    info: {
      main: '#29b6f6', // Azul informação
      dark: '#0288d1',
      light: '#4fc3f7',
      contrastText: '#000000',
    },
    success: {
      main: '#66bb6a', // Verde sucesso
      dark: '#388e3c',
      light: '#81c784',
      contrastText: '#000000',
    },
    background: {
      paper: '#2d2d2d', // Cinza escuro para cards/superfícies
      default: '#1e1e1e', // Fundo principal mais escuro
    },
    text: {
      primary: '#ffffff', // Texto principal branco
      secondary: '#b0b0b0', // Texto secundário cinza claro
      disabled: '#757575', // Texto desabilitado
    },
    divider: 'rgba(255, 255, 255, 0.12)', // Divisor sutil
    grey: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eeeeee',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    }
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 600,
      color: '#ffffff',
    },
    h2: {
      fontWeight: 600,
      color: '#ffffff',
    },
    h3: {
      fontWeight: 600,
      color: '#ffffff',
    },
    h4: {
      fontWeight: 500,
      color: '#ffffff',
    },
    h5: {
      fontWeight: 500,
      color: '#ffffff',
    },
    h6: {
      fontWeight: 500,
      color: '#ffffff',
    },
    subtitle1: {
      color: '#e0e0e0',
    },
    subtitle2: {
      color: '#b0b0b0',
    },
    body1: {
      color: '#ffffff',
      lineHeight: 1.5,
    },
    body2: {
      color: '#e0e0e0',
      lineHeight: 1.43,
    },
    button: {
      fontWeight: 500,
      textTransform: 'none', // Remove uppercase padrão
    },
    caption: {
      color: '#b0b0b0',
    },
    overline: {
      color: '#b0b0b0',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 8, // Bordas levemente arredondadas
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#2d2d2d',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#2d2d2d',
          boxShadow: '0 2px 12px rgba(0, 0, 0, 0.3)',
          border: '1px solid rgba(255, 255, 255, 0.08)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          textTransform: 'none',
          fontWeight: 500,
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: '#1976d2',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 12px rgba(100, 181, 246, 0.3)',
          },
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          backgroundColor: '#2d2d2d',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
        },
        head: {
          fontWeight: 600,
          backgroundColor: 'rgba(100, 181, 246, 0.08)',
        },
      },
    },
  },
});